import joi from 'joi';

export const success = 'Successful response';

const apiResponseErrorDef = joi.array().items(
	joi.object({
		field: joi.string(),
		codes: joi.string(),
	})
);

export const error = joi.object({
	message: joi.string().default('Validation failed'),
	errors: apiResponseErrorDef,
});

export const notFoundError = joi.object({
	message: joi.string(),
});

export const generateValidationError = () => {
	return {
		code: 422,
		description: 'Validation error',
		schema: error,
	};
};

export const generateNotFoundError = (description = 'Resource not found') => {
	return {
		code: 404,
		description,
		schema: notFoundError,
	};
};
